'use client';

import { createBrowserClient } from '@supabase/ssr';

import { Database } from './database.types';

export function createClient() {
  const client = createBrowserClient<Database>(
    process.env.NEXT_PUBLIC_SUPABASE_URL!,
    process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!,
    {
      // cookieOptions: {
      //   name: 'xp-auth-token',
      // },
      auth: {
        detectSessionInUrl: false,
        flowType: 'implicit',
        persistSession: true,
        autoRefreshToken: true,
        // debug: true,
      },
      isSingleton: true,
    },
  );

  // client.auth.onAuthStateChange((event, session) => {
  //   console.log("Auth state changed:", event, session);
  // });

  return client;
}

export const supabase = createClient();
